import { AutogenModelDestLocation, AutogenRowDestLocation } from "./autogen/AutogenModelDestLocation";

export class ModelDestLocation extends AutogenModelDestLocation<RowDestLocation> {
	constructor() {
		super(RowDestLocation);
	}
}

export class RowDestLocation extends AutogenRowDestLocation {
}